import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/admin/auth.service';

export const adminGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const currentUser = authService.currentUserValue;

    // Check if user has admin access
    if (currentUser && currentUser.allowAdminAccess) {
        return true;
    }

    // Redirect to dashboard if not admin
    console.warn('⚠️ Access denied: Admin access required');
    router.navigate(['/dashboard/default']);
    return false;
};
